import { Loader2 } from 'lucide-react'

import type { ReactElement } from 'react'

/** Placeholder de um bloco enquanto seus dados carregam no telão. */
export function ApresentacaoCarregando({ titulo }: { titulo: string }): ReactElement {
  return (
    <div className="flex h-full flex-col items-center justify-center gap-4 text-center">
      <Loader2 className="text-primary h-10 w-10 animate-spin" aria-hidden />
      <p className="text-muted-foreground text-lg">Carregando {titulo}…</p>
    </div>
  )
}
